import React, {Component} from 'react';
import Title from '../base/title';
import Dropdown from '../base/dropdown';
import RadioGroup from '../base/radiogroup';
import moment from 'moment';
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import api from '../../utils/api';
HighchartsMore(ReactHighcharts.Highcharts);

const months = [];
for(let i = 0; i < 13; i++) {
  months.push(moment().add(i, 'M').format('MMM'));
}

const dummySerie = [
  {
    data: []
  }
];

const defaultConf = {
  chart: {
      type: 'bubble',
      plotBorderWidth: 1,
      zoomType: 'xy'
  },
  title: {
      text: null
  },
  legend: {
    enabled: false
  },
  
  xAxis: {
    crosshair: true,
    gridLineWidth: 1,
    categories: []
  },
  credits: {
      enabled: false
  },
  yAxis: {
      startOnTick: false,
      endOnTick: false,
      title: {
          text: null
      },
      labels: {
          format: '{value} %'
      },
      maxPadding: 0.2,
  },
  tooltip: {
      crosshairs: true,
      formatter: function () {
          let s = '<p><b>' + this.point.name + '</b></p>';
          s += '<p>Diferencial: ' + Math.round(this.point.y * 100) / 100 + ' %</p>';
          s += '<p>Volumen: ' + Math.round(this.point.z) + ' m3</p>';
          return s
      },
      label: {
          zIndex: 999999
      },
      useHTML: true,
  },
  plotOptions: {
      series: {
          animation: false,
          dataLabels: {
              enabled: true,
              inside: true,
              color: '#59595a',
              style: {
                textOutline: 0
              },
              format: '{point.name}'
          }
      }
  },
  legend: {
      enabled: false
  },

};

const defualtPlotLines = [
  {
    color: '#b9b9b9',
    dashStyle: 'line',
    width: 2,
    value: 2,
    label: {
        align: 'right',
        text: 'Limite (VPN; VPD)',
        x: -10
    },
    zIndex: 3
  },
  {
    color: '#fcde6a',
    dashStyle: 'line',
    width: 2,
    value: 4,
    label: {
        align: 'right',
        text: 'Limite (SUPER; FD)',
        x: -10
    },
    zIndex: 3
  }
];

export default class Desvios extends Component {

  constructor(props) {
    super(props);
    defaultConf.series = JSON.parse(JSON.stringify(dummySerie));
    defaultConf.yAxis.plotLines = JSON.parse(JSON.stringify(defualtPlotLines));

    this.state = {
      opened: true,
      loader: ' loader-box',
      months: [{ id:0, label: '' }],
      products: [],
      month: {},
      product: [],
      chart: defaultConf,
      plotLines: defualtPlotLines,
      chartAvailable: true
    };
    
    this.getMonth = this.getMonth.bind(this);
    this.getProducts = this.getProducts.bind(this);
    this.loadChart = this.loadChart.bind(this);
  }

  loadChart(product_list, time) {
    let _self = this;
    if (_self.refs.chart) {
      let url = 'widgets/strategic-drift/?type=' + this.props.level + '&id=' + this.props.id + '&' + product_list.join('&');
      if (!time) time = 'M12';
      url += '&time_reference=' + time;
      api.get(url, true).then(resp => { 

        if (!_self.refs.chart) return;

        let chart = _self.refs.chart.getChart();
        var seriesLength = chart.series[0].data.length;
        for(let i = seriesLength -1; i > -1; i--) {
            chart.series[0].data[i].remove();
        }

        let activeProducts = [];
        _self.state.product.forEach(product => {
          activeProducts.push(product.label);
        });

        resp.data.data.forEach(serie => {
          if (activeProducts.indexOf(serie.name) >= 0) {
            chart.series[0].addPoint(serie);
          }
        });
        
        let plotLines = [];
        resp.data.strategies.forEach(str => {
          plotLines.push({
            color: str.product.color,
            dashStyle: 'line',
            width: 2,
            value: str.difference,
            label: {
                allowOverlap: false,
                align: 'right',
                x: -10
            },
            zIndex: 3
          })
        });

        defaultConf.xAxis.categories = resp.data.categories;
        defaultConf.yAxis.plotLines = plotLines;

        _self.setState({ chart: defaultConf, loader: '', chartAvailable: true });
      });
    }
  }

  componentDidMount() {
    let _self = this;
    api.get('filters/products').then(resp => {
      let product_list = [];
      let products = [];
      resp.data.forEach(prod => {
        products.push({ id: prod.id, label: prod.short_name, active: true, color: prod.color });
        product_list.push('product_list=' + prod.id);
      });

      api.get('filters/time-range/?widget=market-share').then(resp => {
        let months = [{ id: 0, label: "SELECCIONAR" }];
        resp.data.forEach(time => {
          months.push({label: time.description, id: time.id})
        });
        _self.setState({
          months: months,
          products: products,
          product: products,
          month: months[1],
        }, function() {
          _self.refs.products.update();
          _self.refs.period.update(months[1]);
          _self.loadChart(product_list);
        });
      });
    });
  }

  getMonth(item) {
    this.setState({ month: item, chartAvailable: false}, function() {
      let product_list = [];
      this.state.product.forEach(prod => {
        product_list.push('product_list=' + prod.id);
      });
      this.loadChart(product_list, item.id);
    });
  }

  getProducts(item) {
    this.setState({ product: item, chartAvailable: false }, function() {
      let product_list = [];
      this.state.product.forEach(prod => {
        product_list.push('product_list=' + prod.id);
      });
      this.loadChart(product_list, this.state.month.id);
    });
  }

  render() {
    let _self = this;
    return <div className="row">
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ strategy: {}, opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} text="DESVIOS SOBRE ESTRATEGIA" isGray={true} hasIcon={true} />
        {_self.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"marketShare" + this.state.loader}>
                <div className="row">
                  <div className="col s3 no-gutter">
                    <Dropdown ref="period" text='PERIODO:&nbsp;&nbsp;&nbsp;' items={this.state.months}  getItem={this.getMonth} />
                  </div>
                  <div className="col s4 no-gutter">
                    <RadioGroup ref="products" text='PRODUCTO:' items={this.state.products}  getItem={this.getProducts} />
                  </div>
                  <div className="col s5 no-gutter">
                    <Dropdown text='' noIcon={true} items={[{ id: 0, label: "&nbsp;" }]} />
                  </div>
                </div>
                <div>
                  <div className={this.state.chartAvailable ? "chartContainer" : "chartContainer loader"}>
                    <ReactHighcharts config={this.state.chart} ref="chart" />
                  </div>    
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/desvios.js